module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-60x60-26345e50b9977ecac4cb46230b8131e3.png";